import React from 'react';
import HeroStats from './HeroStats';
import { StarIcon, BookOpenIcon } from '../../../components/common/IconsComponent';

const Hero = () => (
  <section
    dir="ltr"
    aria-label="Hero section"
    className="relative overflow-hidden bg-gradient-to-br from-blue-800 via-blue-600 to-blue-400 py-12 lg:py-16"
  >
    {/* Blobs */}
    <div aria-hidden="true" className="pointer-events-none absolute left-0 top-0 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/10 blur-3xl" />
    <div aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 h-96 w-96 translate-x-1/3 translate-y-1/3 rounded-full bg-orange-500/20 blur-3xl" />

    <div className="relative z-10 mx-auto max-w-7xl px-2 sm:px-3 lg:px-4">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">

        {/* Content */}
        <div className="flex flex-col gap-5 text-white">
          <div className="inline-flex w-fit items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium backdrop-blur-sm">
            <StarIcon className="h-4 w-4 fill-yellow-400 text-yellow-400" aria-hidden="true" />
            <span>Trusted by 10,000+ students worldwide</span>
          </div>

          <h1 className="text-4xl font-bold leading-tight md:text-5xl lg:text-6xl">
            Learn From The{' '}
            <span className="text-orange-400">World's Best</span>{' '}
            Teachers
          </h1>

          <p className="max-w-lg text-lg leading-relaxed text-gray-200">
            Connect with expert educators for personalized learning experiences.
            Join live interactive classes from anywhere in the world.
          </p>

          <HeroStats/>

        </div>

        {/* Image */}
        <div className="relative">
          <div className="group relative rotate-2 rounded-2xl bg-white p-3 shadow-2xl transition-transform duration-300 hover:rotate-0">
            <img
              src="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?auto=format&fit=crop&w=1200&q=80"
              alt="Students in a virtual classroom"
              className="aspect-video w-full rounded-xl object-cover"
              loading="eager"
            />

            <div className="absolute -bottom-5 right-2 flex items-center gap-2 rounded-xl bg-white px-5 py-3 shadow-lg sm:-bottom-5 sm:-right-5 sm:px-4 sm:py-3">
              <StarIcon className="h-4 w-4 fill-yellow-400 text-yellow-400 sm:h-5 sm:w-5" aria-hidden="true" />
              <span className="text-xs font-bold text-gray-800 sm:text-sm">4.9 Average Rating</span>
            </div>

            <div className="absolute -top-5 left-2 flex items-center gap-2 rounded-xl bg-orange-500 px-5 py-3 shadow-lg sm:-left-5 sm:-top-5 sm:px-4 sm:py-3">
              <BookOpenIcon className="h-4 w-4 text-white sm:h-5 sm:w-5" aria-hidden="true" />
              <span className="text-xs font-bold text-white sm:text-sm">2,000+ Courses</span>
            </div>
            
          </div>
        </div>

      </div>
    </div>
  </section>
);

export default Hero;